import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { createFuelType, editFuelType } from 'features/fuelManagement/fuelManagementSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const FuelTypesModal = ({ closeModal, value }: { closeModal: any, value?: IFuelTypesModal }) => {
    const [state, setState] = useState(value || {
        name: '',
        standardCost: null,
        description: null
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editFuelType(state) : createFuelType(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            [e.target.name]: e.target.type === 'number' ? Number(e.target.value) : e.target.value
        })

    }

    return <Modal black>
        <Flex column between center>
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Type</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Diesel..' labelText='Name' name='name' value={state.name} onChange={handleChange} nomarg required />
                <Input placeholder='15.' labelText='Standard cost' name='standardCost' value={state.standardCost} onChange={handleChange} nomarg type='number' required />
                <Input height='100px' placeholder='Enter description...' labelText='Description' name='description' type='textarea' value={state.description} onChange={handleChange} nomarg />

            </Flex>
            <Button mt='16' disabled={!state.name || !state.standardCost} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IFuelTypesModal {
    id?: number
    name: string
    standardCost: number
    description: string
}